import { SurveyList, useGetSurveyBySlug } from "modules/NewClientSurvey/common"
import { PageWrapper } from "modules/NewClientSurvey/components/PageWrapper"
import { QuestionnaireCards } from "modules/NewClientSurvey/components/QuestionnaireCards"

interface Props {
    cards: SurveyList[]
    handleClickCardItem: (value: string) => void
    slug: string
}

export function StepOneList({ cards, slug, handleClickCardItem }: Props) {
    const { isFetching: cardsIsFetching } = useGetSurveyBySlug(slug)

    return (
        <PageWrapper>
            <QuestionnaireCards
                items={cards}
                slug={slug}
                isLoading={cardsIsFetching}
                onClickCard={handleClickCardItem}
            />
        </PageWrapper>
    )
}
